import {SliderLH} from "./slider-lh";
import {mix} from "polished";
import {CheckboxLine} from "../checkbox-line/checkbox-line";
import {stateChangeNestedValue} from "../../../../../../../../../react/state-change-nested-value";
import * as React from "react";
import {formatMoneyBig} from "../../../../../../../../language/format-money";
import {formatNumberBig} from "../../../../../../../../language/format-number-big";
import "./range-type.scss";

export const RangeType = ({fieldConfig, state, key, next}) => next({
    labelTop: 19,
    controls: ({showErrors}) => (
        <div className="range-type-4dd">
            {SliderLH({
                low : fieldConfig.values.low,
                high: fieldConfig.values.high,
                state: {
                    value: {
                        from: +state.value[key + "_low" ],
                        to  : +state.value[key + "_high"],
                    },
                    onChange: (v) => state.change((s) => ({
                        ...s,
                        [key + "_low"] : "" + v.from,
                        [key + "_high"]: "" + v.to,
                    }))
                },
                background: mix(.03, "#334150", "white"),
                format: key.indexOf("AGE") > -1 && !fieldConfig.format ? (
                    ageFormat
                ) : ["$ ", "$"].includes(fieldConfig.prefix) ? (
                    bigMoneyFormat
                ) : (
                    defaultFormat(fieldConfig.prefix)
                ),
                xdQaNamePrefix: "Demographics Search "+fieldConfig.labelForUser,
            })}

            {fieldConfig.include_uncoded_records && (
                CheckboxLine({
                    state: {
                        value: state.value[key + "_range_checkbox"] === fieldConfig.include_uncoded_records.value,
                        onChange: (v) => stateChangeNestedValue(state, [key + "_range_checkbox"], () => !v ? undefined : fieldConfig.include_uncoded_records.value),
                    },
                    text: "Include uncoded records",
                    textUI: {blur: true},
                    xdQaName: "Demographics Search "+fieldConfig.labelForUser+" Include uncoded records",
                })
            )}
        </div>
    ),
});


const ageFormat = {
    getLabelLow : (v) => v + " yrs",
    getLabelHigh: (v) => v,
};

const bigMoneyFormat = {
    getLabel : formatMoneyBig,
};

const defaultFormat = (prefix) => !prefix ? {
    getLabel: formatNumberBig,
} : ({
    getLabelLow : (v) => prefix + formatNumberBig(v),
    getLabelHigh: (v) => prefix + formatNumberBig(v),
});

